import { useSetRecoilState } from 'recoil'
import { useEffect } from 'react'
import libraryGroupsAtom from '../libraryGroups.atom'
import libraryDocumentsAtom from '../libraryDocuments.atom'
import eventBus from '@/services/eventBus'
import recoilStateUpdaters from '@/recoil/recoil.stateUpdaters.ts'

const useLibraryEventsSubscriptions = () => {
  const setLibraryGroupsState = useSetRecoilState(libraryGroupsAtom)
  const setLibraryDocumentsState = useSetRecoilState(libraryDocumentsAtom)

  useEffect(() => {
    const createGroupSub = eventBus.sub('libraryGroup.created', (group) => {
      recoilStateUpdaters.itemCreated(setLibraryGroupsState, group)
    })

    const updateGroupSub = eventBus.sub('libraryGroup.updated', (group) => {
      recoilStateUpdaters.itemUpdated(setLibraryGroupsState, group)
    })

    const removeGroupSub = eventBus.sub('libraryGroup.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setLibraryGroupsState, id)
    })

    const createDocumentSub = eventBus.sub('libraryDocument.created', (document) => {
      recoilStateUpdaters.itemCreated(setLibraryDocumentsState, document)
    })

    const updateDocumentSub = eventBus.sub('libraryDocument.updated', (document) => {
      recoilStateUpdaters.itemUpdated(setLibraryDocumentsState, document)
    })

    const removeDocumentSub = eventBus.sub('libraryDocument.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setLibraryDocumentsState, id)
    })

    return () => {
      createGroupSub()
      updateGroupSub()
      removeGroupSub()
      createDocumentSub()
      updateDocumentSub()
      removeDocumentSub()
    }
  }, [])
}

export default useLibraryEventsSubscriptions
